<template>
    <v-col cols="12" md="8" lg="6" class="pa-0 ma-0">
        <slot></slot>
    </v-col>
</template>
